import { compact, concat } from 'lodash';
import { createSelector } from 'reselect';
import { currentPatientSelector } from './patient';
import { primaryCaregiverSelector } from './primaryCaregiver';
import { specialistsSelector } from './specialists';
import { primaryDoctorSelector } from './primaryDoctor';

export const homeAddressesSelector = createSelector(
  [currentPatientSelector, primaryCaregiverSelector],
  (patient, primaryCareGiver) => compact([patient, primaryCareGiver]),
);

export const allDoctorsSelector = createSelector(
  [specialistsSelector, primaryDoctorSelector],
  (specialists, primaryDoctor) =>
    compact(concat(specialists, [primaryDoctor])).filter(
      doctor => doctor.id || doctor.tempId,
    ),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/selectors.js